import { LineChart } from "@mui/x-charts/LineChart";

export default function ProjectsLineChart() {
  return (
   <div className="bg-white h-[300px] w-full rounded-3xl">
      <LineChart
        xAxis={[{ data: [1, 2, 3, 5, 8, 10] }]}
        series={[
          {
            data: [2, 5.5, 2, 8.5, 1.5, 5],
            
          },
        ]}
        height={300}
      />
    </div>
  );
}
